import { darken, createPalette, createFontSizes } from 'utils/styles'

const completePaletteColoursCount = 20
const whitePalette = createPalette('white', 255, 255, 255)
const blackPalette = createPalette('black', 0, 0, 0)

export const colors = {
  primaries: {
    primary1: '#0073DA',
    primary2: '#2596FC',
    primary3: '#098BFF',
    primary4: '#00549F',
    primary5: '#00427D',
  },

  greens: {
    green1: '#109A2B',
    green2: '#4EC262',
    green3: '#2CB043',
    green4: '#047E19',
    green5: '#005F11',
    green6: '#96FFC7',
    green7: '#4AC784',
    green8: '#1E4C35',
  },

  oranges: {
    orange1: '#FFA900',
    orange2: '#FFCA64',
    orange3: '#FFBC39',
    orange4: '#C68300',
    orange5: '#9B6700',
  },

  grays: {
    gray1: '#4D4D4D',
    gray2: '#B7B7B7',
    gray3: '#F3F3F3',
    gray4: '#0B0B0B',
    gray5: '#040303',
    gray6: '#121212',
    gray7: '#3E3E40',
    gray8: '#2B2B2E',
    gray9: '#202122',
  },

  purples: {
    purple1: '#6D61FF',
  },

  red: {
    red5: '#B80F0A',
  },

  errors: {
    error1: '#FFE9E9',
    error2: darken('#FFE9E9', 30),
    error3: '#FF5A44',
  },

  social: {
    facebook: '#3A5A98',
  },

  blues: {
    blue1: '#222630',
  },

  newColors: {
    dark2: '#202122',
  },

  inherit: 'inherit',
  transparent: 'transparent',

  ...whitePalette(completePaletteColoursCount),
  ...blackPalette(completePaletteColoursCount),
}

export const font = {
  family: 'Montserrat, Arial, Helvetica, sans-serif',

  ...createFontSizes(6, 72, 1),

  weight: {
    thin: 100,
    extraLight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    heavy: 900,
  },
}

export const zIndexes = {
  dropdown: 10,
  overlay: 100,
  modal: 101,
  loader: 999,
}

export const measures = {
  unit: 5,
  half: 2.5,
}

export default {
  colors,
  measures,
}

// Moving toward typescript and theming
export const spacing = (...args) =>
  args.map((value) => `${value * measures.unit}px`).join(' ')
